namespace GeniuzPOS.InitialData {
    export interface PsPurposeReasonRow {
        Id?: number;
        PurposeCode?: string;
        Purpose?: string;
        Remark?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
        DocType?: string;
    }

    export namespace PsPurposeReasonRow {
        export const idProperty = 'PurposeCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'InitialData.PsPurposeReason';
        export const lookupKey = 'InitialData.PsPurposeReason';

        export function getLookup(): Q.Lookup<PsPurposeReasonRow> {
            return Q.getLookup<PsPurposeReasonRow>('InitialData.PsPurposeReason');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เหตุผลการคืน:Modify';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เหตุผลการคืน:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เหตุผลการคืน:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เหตุผลการคืน:Modify';

        export declare const enum Fields {
            Id = "Id",
            PurposeCode = "PurposeCode",
            Purpose = "Purpose",
            Remark = "Remark",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName",
            DocType = "DocType"
        }
    }
}
